<template>
  <div id="app">
    <navbar/>
    <transition name="trans-router">
      <router-view class="view"/>
    </transition>
    <v-footer/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    setTitle () {
      const titleStart = this.$route.meta.title
      let titleEnd = ' | Wisteria Lodge'

      document.title = titleStart + titleEnd
    }
  },
  watch: {
    $route (to, from) {
      window.scrollTo(0, 0)
      this.setTitle()
    }
  },
  beforeMount () {
    this.setTitle()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue